import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider } from '@react-keycloak/web';

/**Keylcoak instance, this will be initialzied by AuthproviderContext component */
export const keycloak = new Keycloak('/keycloak.json');

export function getToken() {
  return keycloak.token;
}

export function AuthProviderContext(props) {
  const eventLogger = (event, error) => {
    if (window.__dev__) console.log('onKeycloakEvent', event, error);
  };

  const tokenLogger = tokens => {
    if (window.__dev__) console.log('onKeycloakTokens', tokens);
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
      initOptions={{ onLoad: 'login-required' }}
      LoadingComponent={<div>Loading...</div>}
      {...props}
    />
  );
}
